import React from 'react'
import Button from '../Button'
import Modal from '../Modal'
import { FOCUS, SIGNAL } from '../../assets'
import './Instruction.scss'

interface InstructionProps {
  setInstructionVisible: (visible: boolean) => void
  languageConfig: any
  clientConfig: any
}

interface InstructionItemProps {
  imageSrc: string
  title: string
  subtitle: string
  clientConfig: any,
}

const InstructionItem: React.FC<InstructionItemProps> = ({ imageSrc, title, subtitle, clientConfig }) => {
  return (
    <div className='EachInstruction'>
      <div>
        <img src={imageSrc} alt={`${title} Icon`} />
      </div>
      <div className='InstructionTitle'>{title}</div>
      <div className='InstructionSubTitle'>{subtitle}</div>
    </div>
  )
}

const Instruction: React.FC<InstructionProps> = ({ setInstructionVisible, languageConfig, clientConfig }) => {
  const buttonColor = clientConfig?.primaryColor || '';
  return (
    <Modal>
      <div
        className='ModalBody'
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '100%',
          flexWrap: 'wrap',
          paddingTop: 45,
        }}
      >
        <InstructionItem
          imageSrc={FOCUS}
          title={languageConfig.clearFocus}
          subtitle={languageConfig.clearFocusDetail}
        />
        <InstructionItem
          imageSrc={SIGNAL}
          title={languageConfig.fastInternet}
          subtitle={languageConfig.fastInternetDetail}
        />
        <div>
          <Button 
              onClick={() => setInstructionVisible(false)}    
              style={{ width: '100%', borderRadius: 32, padding: '10px 38px', background: buttonColor }}
              text={languageConfig.understoodStartScanning}/>
        </div>
      </div>
    </Modal>
  )
}

export default Instruction
